import styled from '@emotion/styled'
import { SList } from 'components/List'
import { Caption, Text } from 'components/Typography'

export const SSubtitle = styled(Caption)`
  margin-bottom: 1rem;
  color: black;
`

export const SText = styled(Text)`
  margin-bottom: 1.5rem;
`

export const SSList = styled(SList)`
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  margin-bottom: 1.5rem;
  column-gap: 1rem;
`
